














import { InventoryAdvancePaymentStatus } from '@/models';

import Vue from 'vue';
export default Vue.extend({
  name: 'InventoryAdvancePaymentStatusDisplay',

  props: {
    status: { type: InventoryAdvancePaymentStatus, required: true }
  }
});
